"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var screensFeatureFlags_native_exports = {};
__export(screensFeatureFlags_native_exports, {
  initScreensFeatureFlags: () => initScreensFeatureFlags
});
module.exports = __toCommonJS(screensFeatureFlags_native_exports);
var hasInitialized = false;
function initScreensFeatureFlags() {
  if (hasInitialized) return;
  hasInitialized = true;
  try {
    var { featureFlags } = require("react-native-screens");
    if (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.experiment) {
      featureFlags.experiment.synchronousScreenUpdatesEnabled = true;
      featureFlags.experiment.synchronousHeaderConfigUpdatesEnabled = true;
      featureFlags.experiment.synchronousHeaderSubviewUpdatesEnabled = true;
      featureFlags.experiment.iosPreventReattachmentOfDismissedScreens = true;
    }
  } catch (unused) {
  }
}
//# sourceMappingURL=screensFeatureFlags.native.js.map
